// extracted by mini-css-extract-plugin
export default {"button":"ResumeDownload_button__Y-DX3","span":"ResumeDownload_span__7U-W5"};